<template lang="pug">
.page-grid
  .page-grid__column.page-grid__column--100
      BookingsOverviewFilters
      BookingsOverviewTable
      .align-middle
        BookingsPagination
</template>

<script>
import BookingsOverviewFilters from './overview/BookingsOverviewFilters'
import BookingsOverviewTable from './overview/BookingsOverviewTable'
import BookingsPagination from './overview/BookingsPagination.vue';

export default {
  name: 'BookingsOverview',
  components: {
    BookingsOverviewFilters,
    BookingsOverviewTable,
    BookingsPagination
  }
}
</script>

<style scoped lang="stylus">
.align-middle
  display: flex;
  justify-content: center;
</style>